import type { ReactNode } from 'react';

// Minimal hover tooltip — shows on group-hover, no JS positioning logic
// (fixed above the trigger). Used for short, one-line hints like a
// cancellation reason on a status badge.
export function Tooltip({ content, children }: { content: ReactNode; children: ReactNode }) {
  return (
    <span className="relative inline-flex group">
      {children}
      <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-max max-w-[240px] rounded-lg bg-ink text-white text-[11px] leading-snug px-2.5 py-1.5 opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-150 ease-premium z-50 shadow-pop">
        {content}
        <span className="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 bg-ink rotate-45 -mt-1" />
      </span>
    </span>
  );
}
